function layoutGridColumnRule(id){
    const columns = document.querySelectorAll('#' + id + ' > [data-block-type="column"]');

    const resultDesktop = [...columns]
        .filter(el => el.classList.contains('both') || el.classList.contains('desktop'))
        .map(el => el.dataset.columnRuleDesktop)
        .filter(Boolean)
        .join(' ');

    const resultMobile = [...columns]
        .filter(el => el.classList.contains('both') || el.classList.contains('mobile'))
        .map(el => el.dataset.columnRuleMobile)
        .filter(Boolean)
        .join(' ');

    const parent = document.getElementById(id);
    parent.dataset.columnsRulesDesktop = resultDesktop;
    parent.style.setProperty('--columns-rules-desktop', resultDesktop);

    parent.dataset.columnsRulesMobile = resultMobile;
    parent.style.setProperty('--columns-rules-mobile', resultMobile);

    //console.log("COLUMN RULES: ", id, resultDesktop, resultMobile);
}

function addClassToStrong(blockId, className) {
  const block = document.getElementById(blockId);
  if (!block) {
    console.warn(`Elemento con id "${blockId}" non trovato.`);
    return;
  }

  const strongElements = block.querySelectorAll('strong');
  strongElements.forEach(el => el.classList.add(className));

  //console.log(`Classe "${className}" aggiunta a ${strongElements.length} elementi <strong>.`);
}


function openAccordion(id){
  $("#" + id).toggleClass("open");
  $("#" + id + " .accordion-body").slideToggle();
}